module.exports = __webpack_public_path__ + "static/img/childrens-ministry.df867eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ministries/childrens-ministry.jpg
// module id = DIZk
// module chunks = 1